import {Component} from '@angular/core';
import {FormInlineiframeComponent} from "../form-inlineiframe/form-inlineiframe.component";

@Component({
  selector: 'tig-form-usermanagement',
  templateUrl: '../form-inlineiframe/form-inlineiframe.component.html',
  styleUrls: ['../form-inlineiframe/form-inlineiframe.component.scss']
})
export class FormUsermanagementComponent extends FormInlineiframeComponent
{

	public static IFRAME_ID = 'iframe-usermanagement'

	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormUsermanagementComponent.IFRAME_ID;
	} // end function getIFrameID

}
